import { render, staticRenderFns } from "./CouponBatchDispatch.vue?vue&type=template&id=0cdfa3b7&scoped=true"
import script from "./CouponBatchDispatch.vue?vue&type=script&lang=js"
export * from "./CouponBatchDispatch.vue?vue&type=script&lang=js"
import style0 from "./CouponBatchDispatch.vue?vue&type=style&index=0&id=0cdfa3b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdfa3b7",
  null
  
)

export default component.exports